import React from 'react';
import { Button } from 'antd';
import { Colors } from '@common/tokens';
import { Icon, Form, Input } from '@common/components';
export type SignInEmailFormRecordType = {
  email: string;
};

type Props = {
  initialEmail?: string;
  onFinish: (params: SignInEmailFormRecordType) => void;
};

export function SignInEmailForm({ initialEmail, onFinish }: Props) {
  const onFormFinish = (values: { email: string }) => {
    onFinish({ email: values.email });
  };

  return (
    <div className="sign-in-email-form">
      <Form initialValues={{ email: initialEmail }} onFinish={onFormFinish}>
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: 'Please input your email',
            },
            {
              type: 'email',
              message: 'Please enter a valid email address',
            },
          ]}
        >
          <Input
            prefix={<Icon icon="envelope" kind="light" />}
            placeholder="email address"
            size="large"
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="sign-in-form-button"
            size="large"
          >
            Continue
          </Button>
        </Form.Item>
      </Form>
      <style jsx>{`
        .sign-in-email-form {
          width: 100%;
        }

        .sign-in-email-form :global(.ant-input-prefix) {
          color: ${Colors.steelDarker};
        }
        .sign-in-email-form :global(input) {
          padding-left: 0.4rem;
        }

        .sign-in-email-form :global(.sign-in-form-button) {
          width: auto;
        }
      `}</style>
    </div>
  );
}
